import {
  Component,
  Input,
  ElementRef,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Output,
  signal,
  OnChanges,
  SimpleChanges,
  computed,
} from '@angular/core';
import { IconComponent } from '@degreed/apollo-angular';
import { CdkMenuTrigger, CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { TranslateFn, translateWithDefaults } from '@app/shared/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-tag-privacy-dropdown-v3',
  templateUrl: './tag-privacy-dropdown-v3.component.html',
  imports: [IconComponent, CdkMenuTrigger, CdkMenu, CdkMenuItem],
  standalone: true,
})
export class TagPrivacyDropdownV3Component implements OnChanges {
  @ViewChild('privacyButton')
  public privacyButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('dropdown', { read: TemplateRef })
  public dropdownTemplate!: TemplateRef<unknown>;
  @ViewChild('listBox') public listBox!: ElementRef<HTMLElement>;
  @ViewChild(CdkMenuTrigger) public menuTrigger!: CdkMenuTrigger;

  @Output() public setTagPrivacy: EventEmitter<{
    privacyId: number;
  }> = new EventEmitter();
  @Input() public privacyId: number = 0;
  public selectedPrivacy = signal(this.privacyId);

  public privacyOptions = [];
  public selected = computed(() =>
    this.privacyOptions.find((d) => d.privacyId === this.selectedPrivacy())
  );
  public isOpen = false;
  public activeIndex = -1;
  public translate: TranslateFn;

  constructor(
    private translateService: TranslateService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.translate = translateWithDefaults(translateService);
    this.privacyOptions = [
      {
        label: this.translate('Private', 'Core_Private'),
        icon: 'eye-slash',
        description: this.translate(
          'Visible only to you',
          'Core_Private_description'
        ),
        privacyId: 0,
      },
      {
        label: this.translate('Public', 'Core_public'),
        icon: 'eye',
        description: this.translate(
          'Visible to everyone',
          'Core_public_description'
        ),
        privacyId: 1,
      },
    ];
  }
  public ngOnChanges(changes: SimpleChanges) {
    if (changes.privacyId) {
      this.selectedPrivacy.set(changes.privacyId.currentValue);
    }
  }
  public handleSelect({ privacyId }) {
    // this.selected.set(item);
    this.setTagPrivacy.emit({
      privacyId,
    });
    this.selectedPrivacy.set(privacyId);
    this.menuTrigger.close();
    setTimeout(() => {
      this.privacyButton?.nativeElement?.focus();
    });
  }
}
